import BillReleaseForm from "./BillReleaseForm";
import {useState} from "react";

const CreateBillRelease = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Bill Release", url: "/bill-release"},
        {content: "Add Bill Release", url: ""},
    ]);

    return (
        <>
            <BillReleaseForm crumbs={crumbs} title={"Add Bill Release"} btnText={"Create"}/>
        </>
    )
}
export default CreateBillRelease;